import React, { useEffect, useState } from 'react';
import { ControlsWrapper } from './ControlsContainer.styles';
import { useEsriMapContext } from '../../EsriMapContext';
import NavigationControl from './components/NavigationControl/NavigationControl';
import ExtentsControl from './components/ExtentsControl/ExtentsControl';
import GeolocateControl from './components/GeolocateControl/GeolocateControl';
import type { Controls } from '../useControls';
import { functionalityEnabled } from '@Map/utils';
import { MapFunction } from '@Map/types';

interface ControlsContainerProps {
	children?: React.ReactNode;
	layerPanelOpen: boolean;
	controls: Controls;
	// TODO: ESRI-translate — add layerPanelEditorOpen once the style editor is translated
}

export const ControlsContainer = ({
	layerPanelOpen,
	controls,
	children,
}: ControlsContainerProps) => {
	const { view, displayMode } = useEsriMapContext();
	const showGeolocate = functionalityEnabled(
		MapFunction.geolocateControl,
		displayMode,
	);
	const showFitExtents = functionalityEnabled(
		MapFunction.extentsControl,
		displayMode,
	);
	const [top, setTop] = useState(0);

	// Offset below native ESRI top-right widgets (mirrors Mapbox: measures
	// mapboxgl-ctrl-top-right height after load).
	useEffect(() => {
		if (!view) return;
		view.when(() => {
			const topRightUI =
				view.ui.container?.querySelector('.esri-ui-top-right');
			const height = topRightUI?.getBoundingClientRect().height ?? 0;
			setTop(height);
		});
	}, [view]);

	return (
		<ControlsWrapper top={top} layerPanelOpen={layerPanelOpen}>
			<NavigationControl controls={controls} />
			{showGeolocate && <GeolocateControl controls={controls} />}
			{showFitExtents && <ExtentsControl controls={controls} />}
			{children}
		</ControlsWrapper>
	);
};

export default ControlsContainer;
